import { render } from "./GemeindeView.vue?vue&type=template&id=8a93e466"
import script from "./GemeindeView.vue?vue&type=script&lang=js"
export * from "./GemeindeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__